import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDecimalNumberFormat]'
})
export class DecimalNumberFormatDirective implements OnInit {
  @Input() appDecimalNumberFormat: { decimalPart: number };

  constructor(private el: ElementRef, private control: NgControl) { }

  ngOnInit(): void {
    if (!this.appDecimalNumberFormat) {
      this.appDecimalNumberFormat = { decimalPart: 2 };
    }
  }

  // This function will format the number
  private formatNumber(value: string): string {
    let number = value.replace(/\D/g, ''); // Remove non-digit characters

    if (number === '') {
      return ''
    }

    if (number.length <= 1) {
      return '.' + number; // For single digit, prepend .
    }

    const integerPart = number.slice(0, -this.appDecimalNumberFormat.decimalPart); // Get all digits except the last few
    const decimalPart = number.slice(-this.appDecimalNumberFormat.decimalPart); // Get the last few digits

    if (integerPart === '') {
      return '.' + decimalPart; // If there are no digits before decimal, return ".xx"
    }

    return integerPart + '.' + decimalPart; // Format it as "xx.xx"
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const formattedValue = this.formatNumber(event.target.value);
    this.el.nativeElement.value = formattedValue;
    this.control.control?.setValue(formattedValue);
  }
}

